import commonEn from './catalogs/common/en.json';
import authEn from '../../features/auth/i18n/en.json';
import adminEn from '../../features/admin/i18n/en.json';
import parentEn from '../../features/parent/i18n/en.json';
import portalEn from '../../features/portal/i18n/en.json';
import studentEn from '../../features/student/i18n/en.json';
import subscriptionEn from '../../features/subscription/i18n/en.json';
import { appConfig } from '../config/app';

const targetCatalogs = {
  admin: adminEn,
  parent: parentEn,
  portal: portalEn,
  student: studentEn,
  subscription: subscriptionEn,
};

export function catalogsForTarget(target) {
  const activeTargetCatalog = targetCatalogs[target] || portalEn;
  const reusableDomainCatalogs = target === 'admin' ? [parentEn] : [];
  return [
    commonEn,
    authEn,
    subscriptionEn,
    ...reusableDomainCatalogs,
    activeTargetCatalog,
    runtimeAppCatalog(),
  ];
}

function runtimeAppCatalog() {
  return {
    ...(appConfig.appName ? { 'app.name': appConfig.appName } : {}),
    ...(appConfig.browserTitle ? { 'app.browserTitle': appConfig.browserTitle } : {}),
    ...(appConfig.loginTitle ? { 'auth.login.appTitle': appConfig.loginTitle } : {}),
    ...(appConfig.loginSubtitle ? { 'auth.login.subtitle': appConfig.loginSubtitle } : {}),
  };
}
